<template>
  <div class="step-container">
    <Step>
      <template v-slot:content>
        <div class="content">
          <lottie-player class="animation" :src="JSON.stringify(require('@/assets/animations/thanks.json'))" :autoplay="true"/>
          <div class="title">תודה ששיתפת אותנו</div>
          <div class="text">התשובות שלך יעזרו לנו להמשיך לשפר את השירות!</div>
        </div>
      </template>
      <template v-slot:footer>
        <RiseupButton
            class="next-button"
            subtitle="לתזרים"
            :action="onClicked"
            :bold="true"/>
      </template>
    </Step>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import { ACTIVATION_SURVEY_STEPS } from '@/pages/responsive-pages/authenticated/survey/activation-survey/consts';
import router from '@/router';
import Step from '../../components/Step';
import Intercom from '../../../../../../Intercom';

export default {
  name: 'EndStep',
  components: {
    Step,
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserGot(`ActivationSurvey${ACTIVATION_SURVEY_STEPS.End}_PageEntered`, this.answers);
    Intercom.update(this.customerId, this.householdName, { activationSurveyCompleted: true });
  },
  computed: {
    ...mapState('activationSurvey', ['answers']),
    ...mapGetters('session', ['householdName']),
    ...mapState('session', ['customerId']),
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    onClicked() {
      Segment.trackUserGot(`ActivationSurvey${this.activeStep}_EndClicked`);
      router.push({ path: '/sr' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

.step-container {
  height: 100%;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20%;

    .animation {
      padding: 4vw;
      margin-bottom: 30px;
    }

    .title {
      font-size: 24px;
      font-weight: 700;
      margin: 10px;
    }

    .text {
      margin-top: 10px;
      font-size: 18px;
      text-align: center;
      line-height: 24px;
    }

    .touch-point {
      margin-top: 24px;
    }
  }

  .next-button {
    width: 100%;
    height: 54px;
  }
}
</style>
